import { User } from '@bessemercws/graphql';

import { useGraphqlService } from '#/services/graphql.service';

export const useBillPay = () => {
  const [billManagerFn] = useGraphqlService().getBillManager();

  const showBillPay = async (data: User) => {
    const billManagerId = data?.additionalServices?.billManagerId ?? '';
    const billManagerResponse = await billManagerFn(billManagerId);
    const xmlString = billManagerResponse && billManagerResponse?.data?.BillManagerSOAPResponse;
    if (!xmlString) {
      return '';
    }

    const parser = new window.DOMParser();
    const xml = parser.parseFromString(xmlString, 'text/xml');
    const redirectHtml =
      xml.getElementsByTagName('ns2:redirectHtml')[0] && xml.getElementsByTagName('ns2:redirectHtml')[0]?.textContent;
    const html = parser.parseFromString(redirectHtml || '', 'text/html');
    const doc = window.open('about:blank', '_blank');

    const head = html.getElementsByTagName('head');
    const body = html.getElementsByTagName('body');
    doc?.document.write(head[0]?.innerHTML + body[0]?.innerHTML);
    doc?.document.forms[0].submit();
  };

  return { showBillPay };
};

export default useBillPay;
